import { useTranslation } from 'react-i18next';

// global components
import Skeleton from '@mui/material/Skeleton';

// icons
import { AppSpacer } from 'components/ui';

// store
import { observer } from 'mobx-react-lite';

type headerPropsTypes = {
  title: string;
};

export const AppPageHeader = observer(({ title }: headerPropsTypes) => {
  const { t } = useTranslation();

  return (
    <>
      <header className='row'>
        <div className='col-2 d-flex'></div>
        <div className='col-8 d-flex align-items-center justify-content-center' style={{ height: '56px' }}>
          <h1
            className='text-center d-inline mb-0 font-25 text-uppercase font-lato font-weight-bold'
            title={title || t('loading')}
            data-test='group-title'
          >
            {title ? (
              title
            ) : (
              <>
                <Skeleton variant='text' height={40} width={300} />
                <span className='sr-only'>{t('loading')}</span>
              </>
            )}
          </h1>
        </div>
        <div className='col-2 d-flex align-items-center'></div>
      </header>

      <AppSpacer space='34px' />
    </>
  );
});

export default AppPageHeader;
